import './internal-app'



// WEBPACK FOOTER //
// ./src/setup.internal.js